// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zBYoS","badges":"styles_badges__31ZcT"};